<template>
  <Export
    :formats="[
            { value: 'png', label: $t('as PNG image') },
        ]"
    :disabled="disabled"
    @export="$emit('export', arguments[0])"
  />
</template>

<script>
  import Export from '@/_legacy/views/Analytics/components/Export.vue';

  export default {
    components: {
      Export,
    },
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
